import React from "react";
import moment from "moment";

const Batch = ({ product }) => {
  const batches = product?.batches || [];

  if (batches.length === 0) {
    return (
      <div className="card">
        <div className="card-body text-center text-muted">
          <i className="bi bi-inbox fs-3 d-block mb-2"></i>
          No Batches Available
        </div>
      </div>
    );
  }

  return (
    <div className="card shadow-sm">
      <div className="card-body p-0">
        <div className="table-responsive rounded">
          <table
            className="table table-bordered table-hover mb-0"
            style={{ fontSize: "13px" }}
          >
            <thead className="table-dark">
              <tr className="text-nowrap">
                <th>S.No.</th>
                <th>Quantity</th>
                <th>Remaining</th>
                <th>Purchase Price (₹)</th>
                <th>Tax Type</th>
                <th>Purchase Date</th>
                <th>Expiry Date</th>
              </tr>
            </thead>

            <tbody>
              {batches.map((b, index) => {
                const hasExpiry =
                  b.expiryDate && moment(b.expiryDate).isValid();

                const isExpired =
                  hasExpiry && moment(b.expiryDate).isBefore(moment(), "day");

                return (
                  <tr key={b._id || index}>
                    <td>{index + 1}</td>
                    <td>{b.quantity}</td>

                    <td
                      className={
                        Number(b.remainingQty) === 0
                          ? "text-danger fw-bold"
                          : "text-success fw-bold"
                      }
                    >
                      {b.remainingQty}
                    </td>

                    <td>{b.purchasePrice ?? 0}</td>

                    <td className="text-capitalize">{b.taxType || "—"}</td>

                    <td>
                      {b.purchaseDate && moment(b.purchaseDate).isValid()
                        ? moment(b.purchaseDate).format("DD MMM, YYYY")
                        : "—"}
                    </td>

                    <td className={isExpired ? "text-danger fw-bold" : ""}>
                      {hasExpiry
                        ? moment(b.expiryDate).format("DD MMM, YYYY")
                        : "—"}

                      {isExpired && (
                        <span className="ms-2 badge bg-danger">Expired</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Batch;
